import { ActionType } from '../../types';

export const GetOrgActions = {
    getOrgCheckStarted: () =>
        ({
            type: 'GetOrgCheck/Started',
        } as const),

    getOrgCheckSucceeded: (data: {}) =>
        ({
            type: 'GetOrgCheck/Succeeded',
            payload: { data },
        } as const),

    getOrgCheckFailed: (errorCode: string) =>
        ({
            type: 'GetOrgCheck/Failed',
            payload: { errorCode },
        } as const),

    getOrgCheckUnmounted: () =>
        ({
            type: 'GetOrgCheck/Unmounted',
        } as const),
};

export type GetOrgActions = ActionType<typeof GetOrgActions>;
